import AgentChat from './components/agent-chat/AgentChat.vue';
import AgentDefinitionForm from './components/agent-platform/AgentDefinitionForm.vue';
import NonHumanIdentityForm from './components/nhi/NonHumanIdentityForm.vue';
import PipelineExecutionGraph from './components/pipeline/PipelineExecutionGraph.vue';

export default function registerAdminVueComponents(app) {
    app.component('agent-chat', AgentChat);
    app.component('agent-definition-form', AgentDefinitionForm);
    app.component('non-human-identity-form', NonHumanIdentityForm);
    app.component('pipeline-execution-graph', PipelineExecutionGraph);
}
